import { AfterContentChecked, AfterContentInit, AfterViewChecked, AfterViewInit, Component, DoCheck, ElementRef, EventEmitter, forwardRef, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, NgModel } from '@angular/forms';
import { SelectOption } from '../../../models/adminmanagement/AdminRole';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrl: './select.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true
    }
  ]
})
export class SelectComponent implements OnChanges, DoCheck {
 
  // [x: string]: any;
  @Input() id: string = '';
  @Input() name: string = '';
  @Input() label: string = '';
  @Input() options: SelectOption[] = [];
  @Input() model: any;
  @Input() value: any;
  @Input() disabled: boolean = false;
  @Input() required: boolean = false;
  @Input() showOriginalValue: boolean = false;
  @Output() selectionChange = new EventEmitter<any>(); 
  @ViewChild('inputModel', { static: true }) inputModel!: NgModel;
  @ViewChild('wrapper', { static: true }) wrapper!: ElementRef;
  @ViewChild('searchInput', { static: false }) searchInput!: ElementRef;
  isActive: boolean = false;

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (this.wrapper && !this.wrapper.nativeElement.contains(event.target)) {
      this.isActive = false;
      if (this.searchInput) {
        this.searchInput.nativeElement.value = '';
        this.onSearchOption({ target: { value: '' } });
      }
    }
  }

  ngOnInit(){
    // this.displayLabel = this.value;
  }
  
  // value: any = '';
  displayLabel = '';

  originOptions: SelectOption[] = [];

  ngDoCheck(): void {
    if(this.value){
      const disLable = this.originOptions.find(x => x.Value == this.value);
      if(disLable)
        this.displayLabel = disLable.Label;
    }else {
      this.displayLabel = '';
    }
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if(this.options && this.options.length >0)
      this.originOptions = JSON.parse(JSON.stringify(this.options));
    else
      this.displayLabel = '';
  }

  onSearchOption(event: any) {
    const searchQuery = event.target.value?.toLowerCase() || '';
    this.options = this.originOptions.filter(op =>
      op.Label.toLowerCase().includes(searchQuery)
    );
  }

  selectBoxClick() {
    this.isActive = !this.isActive;
    if (this.isActive) {
      setTimeout(() => {
        this.searchInput.nativeElement.focus();
      }, 0);
    }
    this.markAsTouched();
  }
  isShowOriginValue(relation: string): boolean {
    if (!relation || !this.options) return false;
    return !this.options.some(
      (item: SelectOption) => item.Value === relation
    );
  }
  clickFun(item: any) {
    this.value = item.Value;
    
    this.isActive = false;
    this.displayLabel = item.Label;
    this.onChange(item.Value);
  }

  // Callback functions for the ControlValueAccessor
  private onChangeCallback: any = () => {};

  onChange(value: any) {
    this.value = value;
    this.onChangeCallback(value);
    this.selectionChange.emit(value); 
  }

  onTouched = () => { };

  writeValue(value: any): void {
    this.value = value || '';
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  markAsTouched(): void {
    if (this.inputModel) {
      this.inputModel.control.markAsTouched();
    }
  }

  markAsUntouched(): void {
    if (this.inputModel) {
      this.inputModel.control.markAsUntouched();
    }
  }

  showRequiredError(): boolean {
    if(this.required && !this.value && this.inputModel?.touched)
      return true;
    return false;
  }
}
